module.exports = __webpack_public_path__ + "img/ok-form.67093fa4.svg";